import { apiFetch } from './api.js';
export async function withLocalTaskCancellation(taskId, runId, externalSignal, execute) {
  const controller = new AbortController();
  const path = `/api/code-ide/schedule/${taskId}/runs/${runId}`;
  const abort = () => {
    controller.abort();
    void apiFetch(`${path}/cancel`, { method: 'POST' }).catch(() => {});
  };
  if (externalSignal?.aborted) abort();
  externalSignal?.addEventListener('abort', abort, { once: true });
  let checking = false;
  const timer = setInterval(async () => {
    if (checking) return;
    checking = true;
    try {
      const response = await apiFetch(path);
      if (response.data?.status === 'cancelled') controller.abort();
    } catch { /* transient offline state: retain the run and retry next tick */
    } finally { checking = false; }
  }, 5000);
  try { return await execute(controller.signal); }
  finally { clearInterval(timer); externalSignal?.removeEventListener('abort', abort); }
}
